import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button, 
  Container, 
  Link,
  TextField,
  Typography,
  makeStyles, 
} from '@material-ui/core';
import Page from 'src/components/Page';
import Loader from "react-loader-spinner";
import { Alert, AlertTitle } from "@material-ui/lab"; 
import { AuthService } from "../../services/";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const roles = [
  {
    value: "Select",
    label: "Please select",
  },  
  {
    value: "Worker",
    label: "I am worker.",
  },
  {
    value: "Client",
    label: "I want to request a work.",
  }, 
];

const RegisterView = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [hasError, sethasError] = useState(false)

  return (
    <Page
      className={classes.root}
      title="Register"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              email: '', 
              password: '',
              passwordConfirmation:'',
              role:''

            }}
            validationSchema={
              Yup.object().shape({
                email: Yup.string().email('Must be a valid email').max(255).required('Email is required'), 
                password: Yup.string().max(255).required('password is required'),
                passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
                role:Yup.string().oneOf(['Worker','Client']).required()
              
              })
            }
            onSubmit={(values,{setSubmitting,setStatus,resetForm}) => {
               // Call register Api
               AuthService.REGISTER_USER(values.email, values.password, values.role)
               .then(({data}) =>{   
                resetForm({});
                  setSubmitting(false);
                  sethasError(false);
                  setStatus("Saved successfully");

                  setTimeout(function(){
                    navigate("/login", { replace: true });
                 }, 2000);//
                    
               })
               .catch(({response})=>{ 
                 const {Message} = response.data;
                 setSubmitting(false);
                 setStatus(Message)
                 sethasError(true);
               }); 
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              resetForm,
              isSubmitting,
              touched,
              values,
              status
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={3}>
                  <Typography
                    color="textPrimary"
                    variant="h2"
                  >
                    Create new account
                  </Typography>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                    Use your email to create new account
                  </Typography>
                </Box>
                {status ? (
                  <Box my={2} align="center">
                    <Alert severity={hasError?"error":"success"}>
                      <AlertTitle>{hasError?"Error":"Success" }</AlertTitle>
                      {status}
                    </Alert>
                  </Box>
                ) : null}
              
                <TextField
                  error={Boolean(touched.email && errors.email)}
                  fullWidth
                  helperText={touched.email && errors.email}
                  label="Email Address"
                  margin="normal"
                  name="email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="email"
                  value={values.email}
                  variant="outlined"
                />
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Password"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                 <TextField
                  error={Boolean(touched.passwordConfirmation && errors.passwordConfirmation)}
                  fullWidth
                  helperText={touched.passwordConfirmation && errors.passwordConfirmation}
                  label="Confirm password"
                  margin="normal"
                  name="passwordConfirmation"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.passwordConfirmation}
                  variant="outlined"
                />
                <TextField
                  fullWidth
                  label="Why do you register, please select."
                  name="role" 
                  margin="normal"
                  select
                  SelectProps={{ native: true }} 
                  variant="outlined"
                  InputLabelProps={{shrink: true,}}
                  error={Boolean(touched.role && errors.role)}
                  helperText={touched.role && errors.role}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.role}
                >
                  {roles.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </TextField>
                <Box my={2} align='center'>
                {!isSubmitting ? ( <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Sign up now
                  </Button> ) : (
                    <Loader
                      type="ThreeDots"
                      color="blue"
                      height={100}
                      width={100}
                    ></Loader>
                  )}
                </Box>
                <Typography
                  color="textSecondary"
                  variant="body1"
                >
                  Have an account? 
                  <Link
                    component={RouterLink}
                    to="/login"
                    variant="h6"
                  >
                    Sign in
                  </Link>
                </Typography>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
  );
};

export default RegisterView;
